export default "__VITE_ASSET__70e097ea__"